import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { ChevronRight, CheckCircle, Calculator, Wallet, Users, Receipt, PieChart, Megaphone, Settings, BarChart3, Target } from 'lucide-react';
import { SERVICES, BENEFITS } from '../../lib/utils';

const iconMap = { Calculator, Wallet, Users, Receipt, PieChart, Megaphone, Settings, BarChart3, Target };

export const ServicesGrid = () => (
  <section className="py-10 md:py-14 lg:py-16 bg-slate-50" data-testid="services-section">
    <div className="container-apex">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <p className="text-[#007f73] font-medium mb-3 text-sm uppercase tracking-wider">Tudo em um só lugar</p>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Além da contabilidade: backoffice completo para sua clínica
        </h2>
        <p className="text-slate-600 text-lg">
          Enquanto cuidamos da sua tributação, também podemos assumir toda a operação administrativa 
          e financeira do seu negócio. Um parceiro único para todas as suas necessidades de gestão.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.filter(s => s.id !== 'contabilidade').map((service) => {
          const Icon = iconMap[service.icon];
          return (
            <Link key={service.id} to={`/servico/${service.id}`} className="group" data-testid={`service-card-${service.id}`}>
              <Card className="h-full bg-white border-slate-100 hover:border-[#1e4e7e]/20 hover:shadow-md transition-all duration-300">
                <CardContent className="p-6">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#1e4e7e]/10 to-[#007f73]/10 flex items-center justify-center mb-4 group-hover:from-[#1e4e7e] group-hover:to-[#007f73] transition-all duration-300">
                    <Icon className="w-6 h-6 text-[#1e4e7e] group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2 group-hover:text-[#1e4e7e] transition-colors">{service.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{service.description}</p>
                  <div className="mt-4 flex items-center text-[#007f73] text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                    Saiba mais <ChevronRight className="w-4 h-4 ml-1" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
      <div className="text-center mt-12">
        <Button asChild variant="outline" className="btn-secondary rounded-md px-8">
          <Link to="/servicos">
            Ver detalhes de todos os serviços
            <ChevronRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </div>
  </section>
);

export const BenefitsSection = () => (
  <section className="py-10 md:py-14 lg:py-16 bg-white" data-testid="benefits-section">
    <div className="container-apex">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <p className="text-[#007f73] font-medium mb-3 text-sm uppercase tracking-wider">Por que a Apex</p>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          O que nos diferencia de contabilidades tradicionais
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {BENEFITS.map((benefit, index) => (
          <div key={index} className="text-center p-6">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#1e4e7e]/10 to-[#007f73]/10 flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-7 h-7 text-[#007f73]" />
            </div>
            <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2">{benefit.title}</h3>
            <p className="text-slate-600 text-sm">{benefit.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
